import React from 'react';

import styled from '@emotion/styled';
import { ArrowBack } from '@mui/icons-material';

import { StyledBackArrowRouterLink } from '../Link/Link';

interface ITableBackComponent {
  path: string;
  text: string;
}

const TableBackComponent: React.FC<ITableBackComponent> = ({ path, text }) => {
  return (
    <LabelArea>
      <StyledBackArrowRouterLink to={`${path}`}>
        <ArrowBack style={{ color: '#F46F3B' }} />
      </StyledBackArrowRouterLink>
      <Label>{text}</Label>
    </LabelArea>
  );
};

export default TableBackComponent;

const LabelArea = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  /* & > svg {
    font-size: 3rem;
  } */

  & > svg:hover {
    cursor: pointer;
  }
`;

const Label = styled.h1`
  color: #2c2421;
  font-size: 1.25rem;
  font-weight: 700;
`;
